const url = require('url')

module.exports = (domains, options) => {
  let single = false
  if (typeof domains === 'string') {
    domains = [domains]
    single = true
  }

  options = Object.assign({}, {
    lower_case: true,
    extract_from_url: true,
    trim_all: true,
    punycode: true
  }, options)

  domains = domains.map(domain => {
    try {
      if (options.trim_all) {
        domain = domain.trim()
      }

      if (options.lower_case) {
        domain = domain.toLowerCase()
      }

      if (options.extract_from_url) {
        const matches = domain.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i)
        if (matches && matches[1]) {
          domain = matches[1]
        }
      }

      if (options.trim_all) {
        domain = domain.trim()
      }

      if (options.punycode) {
        domain = url.domainToASCII(domain)
      }

      return domain
    } catch (e) {
      return ''
    }
  })

  if (single) return domains[0]
  else return domains
}